<template>
  <div>
    <header class="jumbo-page-header">
      <h1 class="locator-title" id="aria-label_contact" tabindex="-1" style="outline: none">
        Contact Us
      </h1>
      <p :style="{ 'font-size': 'small' }" class="locator-subtitle ml-4 pb-2">
        Let us know what you think!
      </p>
    </header>

    <main role="main">
      <div class="container px-3">
        <form
          @submit.prevent="submit"
          @keydown="errors.clear($event.target.name)"
          v-if="!showThankYou"
        >
          <div class="field">
            <div class="flexbox">
              <label class="label" for="name">Name:</label>
              <span class="has-text-danger" v-text="errors.get('name')" role="alert"></span>
            </div>
            <div class="control has-icons-left">
              <input
                type="text"
                placeholder="Jane Smith"
                id="name"
                class="input"
                v-model="name"
                required
              />
              <span class="icon is-small is-left">
                <i class="fas fa-user"></i>
              </span>
            </div>
          </div>
          <div class="field">
            <div class="flexbox">
              <label class="label" for="email">Email:</label>
              <span class="has-text-danger" v-text="errors.get('email')" role="alert"></span>
            </div>
            <div class="control has-icons-left">
              <input
                type="email"
                placeholder="jane.smith@mpsaz.org"
                id="email"
                class="input"
                v-model="email"
                required
              />
              <span class="icon is-small is-left">
                <i class="fas fa-envelope"></i>
              </span>
            </div>
          </div>
          <div class="field">
            <div class="flexbox">
              <label class="label">Message Type:</label>
              <span class="has-text-danger" v-text="errors.get('type')" role="alert"></span>
            </div>
            <div class="control radio-section">
              <label class="radio">
                <input type="radio" value="Technical Problem" name="type" v-model="type" required />
                Technical Problem
              </label>
              <label class="radio">
                <input type="radio" value="Feature Request" name="type" v-model="type" /> Feature
                Request
              </label>
              <label class="radio">
                <input type="radio" value="Site Accessibility Problem" name="type" v-model="type" />
                Site Accessibility Problem
              </label>
              <label class="radio">
                <input type="radio" value="General Feedback" name="type" v-model="type" /> General
                Feedback
              </label>
            </div>
          </div>
          <div class="field">
            <div class="flexbox">
              <label class="label" for="message">Message:</label>
              <span class="has-text-danger" v-text="errors.get('message')" role="alert"></span>
            </div>
            <div class="control">
              <textarea
                class="textarea is-medium"
                id="message"
                v-model="message"
                required
              ></textarea>
            </div>
          </div>
          <div class="field">
            <div class="control is-clearfix">
              <button
                type="submit"
                class="button is-medium is-pulled-right"
                :class="{ 'is-loading': isLoading }"
              >
                Submit
              </button>
            </div>
          </div>
        </form>

        <div class="thank-you-msg" v-else>
          <div></div>
          <div>
            <h3>Thank you for sending a message!</h3>
            <p>If necessary we will follow up with you soon.</p>
          </div>
          <button class="button is-large" @click="showThankYou = false">
            Send another message
          </button>
        </div>
      </div>
      <!-- end container -->
    </main>
  </div>
</template>

<script>
import { Errors } from "@/helpers/errors.js";

export default {
  data() {
    return {
      name: "",
      email: "",
      type: "",
      message: "",
      errors: new Errors(),
      isLoading: false,
      showThankYou: false,
    };
  },
  methods: {
    submit(e) {
      this.isLoading = true;
      this.axios
        .post("/api/v1/contact-form-submit", {
          name: this.name,
          email: this.email,
          type: this.type,
          message: this.message,
        })
        .then((response) => {
          this.isLoading = false;
          this.showThankYou = true;
          this.errors.reset();
          this.name = "";
          this.email = "";
          this.type = "";
          this.message = "";
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response.status == 422) {
            this.errors.record(error.response.data);
          } else {
            this.errors.record({ general: ["Sorry something went wrong. Please try again."] });
          }
        });
    },
  },
  mounted() {
    document.querySelector("#aria-label_contact").focus();
  },
};
</script>

<style lang="scss" scoped>
form {
  height: 100%;
  width: 100%;
  max-width: 960px;
  padding: 0.75rem;
  margin: 0 auto;
  background-color: #c8d9ce;
  font-family: "Roboto", sans-serif;

  .field {
    color: #000;
    margin: 0;
  }
  .control {
    margin: 0.5rem 0 1rem 0;
  }
  .radio {
    margin: 0.5rem;
  }
  button[type="submit"] {
    background-color: #9574b4;
    color: #fff;
  }
}
.radio-section {
  display: flex;
  flex-direction: column;
}
.flexbox {
  display: flex;
  align-items: center;
  label {
    color: #000;
    margin: 0;
  }
  span {
    flex-grow: 1;
    text-align: right;
  }
}
.thank-you-msg {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 619px;
  width: 100%;
  text-align: center;
  padding: 0.75rem;
  margin: 0 auto;
  font-family: "Roboto", sans-serif;
  h3 {
    font-size: 2rem;
  }
  p {
    font-size: 1rem;
  }
  button {
    border: 0;
    color: #f5f5f5;
    background-color: #9575b6;
    &:hover {
      cursor: pointer;
      background-color: #126;
    }
  }
}
@media screen and (min-width: 769px) {
  .thank-you-msg {
    h3 {
      font-size: 3rem;
    }
  }
}
</style>
